<template>
  <div>
    <!-- grid toolbar -->
    <v-toolbar flat color="transparent" class="v-toolbar--grid">
      <!-- grid filter -->
      <v-menu
        v-model="filter.dialog"
        :close-on-content-click="false"
        :offset-y="true"
        max-width="300px"
        min-width="300px"
      >
        <template v-slot:activator="{ on }">
          <!-- filter button -->
          <v-btn
            class="mr-2"
            large
            v-on="on"
            :class="{ 'teal--text': filter.active }"
          >
            <v-icon>mdi-tune</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-form ref="form" @submit.prevent="getItems">
            <v-card-title>Filter</v-card-title>
            <v-divider />
            <v-card-text>
              <v-text-field
                v-model="filter.data.KodeSekolah"
                hide-details
                outlined
                placeholder="Cari berdasar kode sekolah"
                label="Kode Sekolah"
                dense
                class="mb-3"
              ></v-text-field>
              <v-text-field
                v-model="filter.data.NamaSekolah"
                hide-details
                outlined
                dense
                class="mb-3"
                placeholder="Cari berdasar nama sekolah"
                label="Nama Sekolah"
              ></v-text-field>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text @click="clearFilter">Ulang</v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="doFilter">Cari</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>

      <!-- grid search -->
      <v-text-field
        v-model="search.data"
        append-icon="mdi-magnify"
        :label="app.grid.search"
        hide-details
        single-line
        solo
        clearable
      ></v-text-field>
      <v-spacer />
      <v-btn class="ml-2" color="green white--text" large  @click="exportExcel">
        <span class="hidden-xs-only">Export Excel</span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-file-excel</v-icon>
      </v-btn>
      <!-- grid button -->
    </v-toolbar>

    <!-- grid -->
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :loading-text="app.grid.loading"
      :no-data-text="app.grid.noData"
      multi-sort
      :hide-default-header="true"
      id="table-bosnas"
      class="elevation-1"
    >
      <template v-slot:headers="{}"> </template>
      <template v-slot:header="{}">
        <tr>
          <th rowspan="2" class="text-center">Nama Sekolah</th>
          <th colspan="2" rowspan="2" class="text-center">Penerimaan</th>
          <th colspan="4" class="text-center">Belanja</th>
          <th rowspan="2" class="text-center">Total</th>
        </tr>
        <tr>
          <th class="text-center">Pegawai</th>
          <th class="text-center">Barang & Jasa</th>
          <th class="text-center">Modal P&M</th>
          <th class="text-center">Modal Aset Tetap & Lainnya</th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
// import VBtnExpand from "../../../components/VBtnExpand.vue";

export default {
  // components: { VBtnExpand },
  data() {
    return {
      filter: {
        dialog: false,
        active: false,
        data: {
          KodeSekolah: "",
          NamaSekolah: "",
        },
        query: {},
      },
      sort: {
        active: false,
      },
      search: {
        awaiting: false,
        data: "",
      },
      table: {
        awaiting: false,
      },
      loading: false,
      options: {},
      headers: [
        {
          value: "NamaSekolah",
          width: "10%",
        },
        {
          value: "Penerimaan",
          width: "5%",
        },
        {
          value: "Silpa",
          width: "5%",
        },
        {
          value: "BelanjaPegawai",
          width: "5%",
        },
        {
          value: "BelanjaBarjas",
          width: "5%",
        },
        {
          value: "BelanjaPermes",
          width: "5%",
        },
        {
          value: "BelanjaAssetLain",
          width: "5%",
        },
        {
          value: "Total",
          width: "5%",
        },
      ],
      items: [],
      totalItems: 0,
    };
  },
  computed: {
    ...mapState({
      app: (state) => state.app,
    }),
  },
  methods: {
    async getItems() {
      this.loading = true;
      let payload = this.$format.payload(this.options);
      payload.Filter = this.filter.query;
      payload.KeywordFields = ["Kode", "Nama"];
      payload.Keyword = this.filter.active
        ? ""
        : this.$format.keyword(this.search.data);

      if (payload.Orders.length == 0) payload.Orders = ["-LastUpdatedDate"];
      this.$axios
        .post("/bosda/list", payload)
        .then((res) => {
          const result = res.data;
          this.items = result.Data;
          this.totalItems = result.Total;
        })
        .catch((error) => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportExcel() {
      let payload = this.$format.payload(this.options);
      payload.Filter = this.filter.query;
      payload.KeywordFields = [];
      payload.Keyword = this.filter.active
        ? ""
        : this.$format.keyword(this.search.data);
      payload.Limit = 0;
      if (payload.Orders.length == 0) payload.Orders = ["-CreatedAt"];
      this.$axios
        .post("/bosda/export", payload)
        .then((res) => {
          const result = res.data;
          // this.items = result.Data;
          // this.totalItems = result.Total;
          var url_var = process.env.VUE_APP_API_URL;
          url_var = url_var.substring(0, url_var.length - 4);
          // process.env.baseURL
          // console.log(url_var, result);
          window.location.href = url_var + "download/" + result.Data;
        })
        .catch((error) => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    doFilter() {
      let filter = new this.$dbflex();
      let data = this.filter.data;
      if (data.KodeSekolah != "")
        filter.contain("KodeSekolah", data.KodeSekolah);
      if (data.NamaSekolah != "")
        filter.contain("NamaSekolah", data.NamaSekolah);

      let query = filter.get();
      if (query) {
        this.filter.dialog = false;
        this.filter.active = true;
        this.filter.query = query;
        this.search.data = "";
        this.getItems();
      }
    },
    resetFilter() {
      this.filter.dialog = false;
      this.$refs.form.reset();
    },
    clearFilter() {
      this.$refs.form.reset();
      this.filter.active = false;
      this.filter.query = null;
      this.search.data = "";
      this.getItems();
    },
    clearSort() {
      this.filter.sort = false;
      this.options.sortBy = [];
      this.options.sortDesc = [];
    },
  },
  watch: {
    options: {
      handler(v) {
        var delay = 500;
        if (!this.table.awaiting) {
          setTimeout(() => {
            this.sort.active = v.sortBy.length > 0;
            this.getItems();
            this.table.awaiting = false;
          }, delay);
        }
        this.table.awaiting = true;
      },

      deep: true,
    },
    "search.data"() {
      var delay = 1000;
      if (!this.search.awaiting) {
        setTimeout(() => {
          this.getItems();
          this.search.awaiting = false;
        }, delay);
      }
      this.search.awaiting = true;
    },
    // "filter.data": {
    //   handler: function(newVal, oldVal) {
    //     console.log(">>>", this);
    //     console.log(">>>", newVal, oldVal, newVal == oldVal);
    //   },
    //   deep: true
    // }
  },
  mounted() {},
};
</script>
  
  <style>
#table-bosnas.v-data-table tbody tr td,
#table-bosnas.v-data-table tr th {
  border: thin solid rgba(0, 0, 0, 0.12) !important;
}
</style>